import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, inject } from '@angular/core';

import { EpcotConfig, PriceBoostConfig } from '@frontend/sports/common/client-config-data-access';
import { FontResizerComponent } from '@frontend/sports/common/core/feature/font-resizer';

@Component({
    selector: 'ms-priceboost-count-signpost',
    templateUrl: './priceboost-count-signpost.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FontResizerComponent],
})
export class PriceboostCountSignpostComponent implements OnInit {
    priceBoostConfig = inject(PriceBoostConfig);
    private epcotConfig = inject(EpcotConfig);

    @HostBinding('class') className = 'count-signpost-container';
    @HostBinding('class.large-signpost') largeSignpost = false;
    @HostBinding('class.count-signpost') countSignpost: boolean;

    @HostBinding('class.epcot-signpost')
    get shouldApplyClass(): boolean {
        return this.epcotConfig.isEnabled;
    }

    @Input() count: string;
    @Input() isLargeSignPost = false;
    showPriceBoostCount = false;

    ngOnInit(): void {
        this.showPriceBoostCount = this.priceBoostConfig.showCount || this.isLargeSignPost;
        this.largeSignpost = this.isLargeSignPost;
        this.countSignpost = !this.isLargeSignPost;
    }
}
